import { useQuery } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const _endpoint:string = 'donations/{parentId}/entries';
const endpoint = (parentId) => {
    return _endpoint.replace('{parentId}', parentId);
}

export function useGetAllDonationEntries(parentId:number, params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint(parentId)], ...queryParams}, params);
}

export function useGetDonationEntry(parentId:number, id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint(parentId), id], ...params});
}

export function useCreateDonationEntry(parentId:number) {
    return useCreate({queryKey: [endpoint(parentId)]});
}

export function useUpdateDonationEntry({parentId, id}) {
    return useUpdate({queryKey: [endpoint(parentId), id]});
}

export function useDeleteDonationEntry({parentId, id}) {
    return useDelete({queryKey: [endpoint(parentId), id]});
}
